<template>
    <form-container v-on:save="saveTarget" :header="translate('circulationProfileSchema.targetSystems')" :disabled="loading" class="roundbox">
        <template v-slot:tabs>
            <tab :tabs="tabs" v-model="tab" ref="tab"></tab>
        </template>
        <fieldset id="tab-genel" class="tab-panel" v-show="tab == 'genel'">
            <div class="row">
                
                <div class="col col-xs-10 col-sm-8 col-md-8 col-lg-6">
                    <div class="form-group row">
                        <label class="col-form-label col-sm-3">{{translate('targetSystem.targetSystemTemplate')}}</label>
                        <div class="col-sm-9">
                            <select-input
                                :value="selectedTemplate"
                                :autocomplete="true"
                                :placeholder="translate('search')"
                                :items="targetSystemTemplates"
                                :filter-function="(item, search) => new RegExp(search, 'i').test(item.Name)"
                                @change="templateSelectChanged"
                                style="width:100%;">
                                    <span v-if="selectedTemplate">
                                        {{selectedTemplate ? selectedTemplate.Name : translate('undefined')}}
                                    </span>
                                    <span v-else>{{translate('targetSystem.selectTargetSystemTemplate')}}</span>
                                    <template v-slot:item="{item}">
                                        <div style="padding:2px 0;">
                                            {{item.Name}}
                                        </div>
                                    </template>
                            </select-input>
                            <small class="text-muted">{{translate('targetSystem.targetSystemTemplateText')}}</small>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-form-label col-sm-3">{{translate('externalSigner.name')}}</label>
                        <div class="col-sm-9">
                            <input v-model="data.Name" type="text" class="form-control" @input="checkInput('Name',$event)" required />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-form-label col-sm-3">{{translate('categoryList.columns.type')}}</label>
                        <div class="col-sm-9">
                            <select v-model="data.Kind" class="form-control" required>
                                <option value="Email">{{translate('customTargetSystem.email')}}</option>
                                <option v-if="hasModule('API')" value="Api">API</option>
                                <option v-if="hasModule('REM')" value="Rem">{{translate('customTargetSystem.kep')}}</option>
                                <option v-if="hasModule('FTP')" value="Ftp">FTP</option>
                                <option v-if="hasModule('SFTP')" value="SFtp">sFTP</option>                            
                                <option v-if="isOnPrem" value="FileSystem">{{translate('fileSystem')}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-form-label col-sm-3">{{translate('draft.department')}}</label>
                        <div class="col-sm-9">
                            <select-input
                                :value="data.DepartmentId"
                                :autocomplete="true"
                                :placeholder="translate('search')"
                                :items="availableDepartments"
                                :isDisabled="setDepartmentDisabled()"
                                :filter-function="(item, search) => new RegExp(search, 'i').test(item.Name)"
                                @change="departmentSelectChanged"
                                style="width:100%;">
                                    <span v-if="data.DepartmentId">
                                        {{selectedDepartment ? selectedDepartment.Name : translate('undefined')}}
                                    </span>
                                    <span v-else>{{translate('circulationProfileSchema.allDepartmentsCanAccess')}}</span>
                                    <template v-slot:item="{item}">
                                        <div style="padding:2px 0;">
                                            {{item.Name}}
                                        </div>
                                    </template>
                            </select-input>
                        </div>
                    </div>
                    <component v-bind:is="data.Kind" v-model="data" @ftpLookupTargetSystem="ftpLookupTargetSystem"></component>                
                    <targetSystemLookup v-if="lookupResult" :lookupResult="lookupResult" @onclose="lookupResult = null" @ftpLookupTargetSystem="ftpLookupTargetSystem" @ftpLookupPathSelected="ftpLookupPathSelected" ></targetSystemLookup>
                    <div class="form-group row">
                        <div class="col-form-label col-sm-3">{{translate('targetSystem.fileLimit')}}</div>
                        <div class="col-sm-9">
                            <file-size-input v-model="data.TotalFileSizeLimit"/>
                            <small class="text-muted">{{translate('targetSystem.fileLimitText')}}</small>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-sm-3"></div>
                        <div class="col-sm-9">
                            <label>
                                <input type="checkbox" v-model="data.IsActive" />
                                {{translate('incomingChannel.targetActive')}}
                            </label>
                        </div>
                    </div>
                    <div class="form-group row" >
                        <div class="col-sm-3">
                        </div>
                        <div class="col-sm-9" >
                        
                        </div>
                        <targetSystemTest v-if="testResult" :testResult="testResult" @onclose="testResult = null"></targetSystemTest>
                    </div>
                </div>
                <div class="col">
                </div>
            </div>
        </fieldset>
        <fieldset id="tab-imzatanim" class="tab-panel" v-show="tab == 'imzatanim'">
            <div class="row">
                <div class="col col-xs-10 col-sm-8 col-md-8 col-lg-6">
                    <div class="form-group row">
                        <label class="col-form-label col-sm-3"> {{translate('draft.signatureStandard')}}</label>
                        <div class="col-sm-9">
                            <select v-model="data.SignatureStandard" class="form-control">
                                <option :value=null>{{translate('targetSystem.sigStandards.notChoosed')}}</option>
                                <option value="PAdES">PAdES (PDF)</option>
                                <option value="CAdES">CAdES ({{translate('targetSystem.sigStandards.parallel')}})</option>
                                <option value="CAdES_Serial">CAdES ({{translate('targetSystem.sigStandards.serial')}})</option>
                                <option value="Guarantee">XAdES ({{translate('targetSystem.sigStandards.guarantee')}})</option>                            
                                <option value="EYP">EYP v1.3</option>                            
                                <option value="EYP2">EYP v2.0</option>                            
                            </select>
                        </div>
                    </div>
                    <div class="form-group row ml-1">
                        <label>
                            <input type="checkbox" v-model="encryptionActive" />
                            {{translate('targetSystem.encryptionActive')}}
                        </label>
                    </div>
                    <div v-if="encryptionActive" class="form-group row">
                        <label class="col-form-label col-sm-3">{{translate('targetSystem.encryptionProvider')}}</label>
                        <div class="col-sm-9">
                            <select v-model="data.EncryptionOptions.EncryptionStandard" class="form-control">
                                <option value="None">{{translate('targetSystem.noProvider')}}</option>
                                <option value="YapiKredi">Yapı Kredi</option>
                                <option value="Garanti">Garanti</option>
                                <option value="Teb">TEB</option>
                            </select>
                        </div>
                    </div>
                    <div v-if="encryptionActive"  class="form-group row">
                        <label class="col-form-label col-sm-3">{{translate('targetSystem.encryptionKey')}}</label>
                        <div class="col">
                            <password v-model="data.EncryptionOptions.EncryptionKey" name="Password" class="form-control"  @change="$forceUpdate()" />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-form-label col-sm-3">{{translate('targetSystem.documentPattern')}}</label>
                        <div class="col-sm-9">
                            <select v-model="data.DocumentFormat" class="form-control">
                                <option value="None">{{translate('targetSystem.noPattern')}}</option>
                                <option value="YapiKredi">Yapı Kredi</option>
                                <option value="Garanti">Garanti</option>
                                <option value="Teb">TEB</option>                  
                                <option value="IsBankasi">İş Bankası</option>                  
                                <option value="Vakifbank">Vakıfbank</option>
                                <option value="YapiKrediYabanci">Yapı Kredi ({{translate('targetSystem.foreignCurrency')}})</option>
                                <option value="GarantiYabanci">Garanti ({{translate('targetSystem.foreignCurrency')}})</option>
                                <option value="TebYabanci">TEB ({{translate('targetSystem.foreignCurrency')}})</option>                  
                                <option value="IsBankasiYabanci">İş Bankası ({{translate('targetSystem.foreignCurrency')}})</option>
                                <option value="YapiKrediYabanciFx">Yapı Kredi ({{translate('targetSystem.foreignCurrency')}} FX)</option>                  
                            </select>
                        </div>
                    </div>
                </div>
                <div class="col">
                    
                </div>
            </div>
        </fieldset>
        <template v-slot:footer>
            <div class="row">
                <div class="col">
                    <button type="button"  v-on:click="goBack" class="btn btn-outline-primary" style="margin-right: 10px;">{{translate('goBack')}}</button>
                    <tab-nav :tabs="tabs" :nextButton="false" v-model="tab"></tab-nav>
                </div>
                <div class="col text-right">
                    <button v-if="isTestAvailable" type="button" class="btn btn-primary" @click="testTargetSystem()" style="margin-right:12px;">
                        {{translate('targetSystem.testTargetSystem')}}
                    </button>
                    <tab-nav :tabs="tabs" :prevButton="false" v-model="tab" style="margin-right:12px;"></tab-nav>
                    <button type="submit" class="btn btn-success" style="margin-right:12px;">{{translate('save')}}</button>
                </div>
            </div> 
        </template>
        <!-- <template v-slot:footer>
                <div class="row">
                    <div class="col col-xs-10 col-sm-8 col-md-8 col-lg-6">
                        <div class="row">
                            <div class="col-4">
                                <button type="button" accesskey="g" v-on:click="goBack" class="btn btn-outline-primary"><u>G</u>eri Dön</button>
                            </div>
                            <div class="col-8 text-right">
                                <button v-if="isTestAvailable" type="button" class="btn btn-primary" @click="testTargetSystem()" style="margin-right:12px;">
                                    Alıcı Erişimini Test Et 
                                </button>
                                <button accesskey="k" type="submit" class="btn btn-success"><u>K</u>aydet</button>
                            </div>
                        </div>
                    </div>
                    <div class="col"></div>

                </div>
            </template> -->
    </form-container>
</template>
<script>
import formMixin from '../formMixin.js';
import formContainer from '../components/FormContainer.vue'
import Email from '../components/TargetSystem/Email.vue'
import Rem from '../components/TargetSystem/Rem.vue'
import Ftp from '../components/TargetSystem/Ftp.vue'
import SFtp from '../components/TargetSystem/Sftp.vue'
import selectInput from '../components/SelectInput.vue'
import targetSystemTest from '../components/TargetSystemTest.vue';
import targetSystemLookup from '../components/TargetSystemLookup.vue';
import axios from "axios";
import fileSizeInput from '../components/FileSizeInput.vue';
import FileSystem from '../components/TargetSystem/FileSystem.vue'
import Api from '../components/TargetSystem/Api.vue';
import tab from '../components/Tab.vue'
import tabNav from '../components/TabNav.vue'
import password from '@/components/Password.vue'



export default {
    mixins: [formMixin],
    components: {
        formContainer,
        Email,
        Rem,
        Ftp,
        SFtp,
        selectInput,
        targetSystemTest,
        targetSystemLookup,
        fileSizeInput,
        FileSystem,
        Api,
        tab,
        tabNav,
        password
    },
    watch:{
        'encryptionActive': function(newEnc) {
      console.log('Enc değişti: ', newEnc);
      if(newEnc) {
        if(this.data.EncryptionOptions == null){
            this.data.EncryptionOptions = {EncryptionStandard:null, EncryptionKey: null}
        }
      }else {
        this.data.EncryptionOptions = null
      }
    },
    },
    computed:{
        selectedDepartment(){
            return this.departments.filter(x => x.Id == this.data.DepartmentId)[0];
        },
        availableDepartments(){
            var result = (this.departments ?? []).filter(x => x.IsActive);

            if(this.hasAuth('Admin') || (this.$root.$data.login.User.DepartmentIds ?? []).length == 0)
                result =  [{Id:'', Name: this.translate('circulationProfileSchema.allDepartmentsCanAccess')}].concat(result);

            return result;
        },
        isTestAvailable() {
          return this.availableTest.includes(this.data.Kind);
        }
    },
    created(){
        this.getDepartments({predicate: "IsActive= true" })
        .then(x => {
            this.departments = x.Result;
        }).catch(x => {
            console.log("Departman listesi yüklenemedi:", x);
        });

        this.getUsers({predicate: "IsActive= true" })
        .then(x => {
            this.userList = x.Result;
        }).catch(x => {
            console.log("Kullanıcı listesi yüklenemedi:", x);
        });

        this.getData(this.$route.params.id, this.$route.query.kind).then(() => {
            if(!this.data.Credential)
                this.data.Credential = { Username: null, Password: null };
            if(this.data.EncryptionOptions != null){
                this.encryptionActive = true
            }else{
                this.data.EncryptionOptions = null;
            }

        });
        this.getTargetSystemTemplates();
    },
    data() {
        return {
            loading: false,
            modelName: 'TargetSystem',
            data: {
                Credential: { Username:null, Password: null },
                EncryptionOptions: { EncryptionStandard:null, EncryptionKey: null}
            },
            tab: 'genel',
            tabs: [
                { key:'genel', text:this.translate('tabs.targetSystemTabs.general') },
                { key:'imzatanim', text:this.translate('tabs.targetSystemTabs.imzatanim') }
            ],
            userList: null,
            departments: [],
            availableTest: ["SFtp", "Ftp", "FileSystem"],
            testResult: null,
            lookupResult: null,
            encryptionActive: false,
            targetSystemTemplates: [],
            selectedTemplate: null
        }
    },
    methods: {
        getTargetSystemTemplates(){
            axios.post("targetsystemtemplate/get", {predicate: "IsActive= true" }).then(x => {
                this.targetSystemTemplates = x.data.Result;
        }).catch(x => {
            console.log("Alıcı taslak listesi yüklenemedi:", x);
        });
            
        },
        saveTarget(){
            console.log(this.data);
            if(!this.encryptionActive)
                this.data.EncryptionOptions = null;
                this.save();
        },
        checkInput(value, event) {
            // Check for invalid characters
            if (/[<>]/.test(event.target.value)) {
                alert(this.translate('errors.invalidSymbols'))
                const editedText = ""
                this.$set(this.data, value, editedText)
            } else {
                this.$set(this.data, value, event.target.value)
            }
        },
        departmentSelectChanged(value){
            this.data.DepartmentId = value?.Id;
        },
        templateSelectChanged(value){
            var oldId = this.data.Id;
            this.data = value;
            axios.get("targetsystemtemplate/get/"+value.Id).then(x => {

                this.data = x.data;
                this.data.Id = oldId;
            }).catch(x => {
                console.log("Alıcı taslak kaydo çekilemedi:", x);
            });
        },
        isNewRecord(){
           if(this.$route.params.id == "000000000000000000000000")
               return true;
            return false;
        },
        setDepartmentDisabled(){
            if(this.isNewRecord())
                return false;
            if(this.hasAuth('Admin') || (this.$root.$data.login.User.DepartmentIds ?? []).length == 0)
                return false;
            if(this.data.DepartmentId)
                return false;
            return true;
        },
        validTargetSystem(){
            var errors = [];

            if(this.data.Kind == "SFtp" || this.data.Kind == "Ftp")
            {
                if (!this.data.Name) {
                    errors.push(this.translate('errors.nameDefRequired'));
                }

                if (!this.data.Host) {
                    errors.push(this.translate('errors.hostDefRequired'));
                }

                if (!this.data.Port) {
                    errors.push(this.translate('errors.portDefRequired'));
                }

                if (!this.data.Credential) {
                    errors.push(this.translate('errors.userAndPasswordDefRequired'));
                }
                else
                {
                    if (!this.data.Credential.Username) {
                        errors.push(this.translate('errors.userDefRequired'));
                    }

                    if (this.data.Credential.Password == null) {
                        errors.push(this.translate('errors.passwordDefRequired'));
                    }
                }

                if (!this.data.Path) {
                    errors.push(this.translate('errors.uzakdizinDefRequired'));
                }
            }

            if(this.data.Kind == "FileSystem")
            {
                if (!this.data.Path) {
                    errors.push(this.translate('errors.dizinDefRequired'));
                }
            }

            if (!errors.length) {
                return true;
            }
            else
            {
                var alertMessage = "";
                errors.forEach(element => {
                    alertMessage += element + "\r\n";
                });

                alert(alertMessage);
            }
        },
        testTargetSystem() {
          if(!this.validTargetSystem())
            return;

          this.loading = true;
          axios
            .post("/TargetSystem/Test", this.data)
            .then((x) => {
              if (x.data.Success) {
                this.testResult = x.data.TestResult;
              } else {
                alert(this.translate('errors.targetCantTested') + x.data.Exception);
              }
              this.$forceUpdate();
            })
            .catch((x) => {
              alert(this.translate('errors.targetCantTested') + x);
            })
            .then(() => {
              this.loading = false;
            });
        },
        ftpLookupTargetSystem(customPath) {
          if(!this.validTargetSystem() || this.loading)
            return;

          this.loading = true;

          var formData = Object.assign({},this.data);

          if(customPath)
            formData.Path = customPath;

          axios
            .post("/TargetSystem/FtpLookup", formData)
            .then((x) => {
              if (x.data.Success) {
                this.lookupResult = { TargetSystem : x.data.TargetSystem, Files : x.data.Files };
              } else {
                alert(this.translate('incomingDoc.lookupFailed') + x.data.Exception);
              }
              this.$forceUpdate();
            })
            .catch((x) => {
              alert(this.translate('incomingDoc.lookupFailed') + x);
            })
            .then(() => {
              this.loading = false;
            });
        },
        ftpLookupPathSelected(value){
            this.data.Path = value;
            this.lookupResult = null;
        },
        goNextTab(){ 
            var curIndex = this.tabs.findIndex(x => x.key == this.tab);
            var newTab = this.tabs[curIndex + 1];
            if(newTab)
                this.goTab(newTab.key);
        },
        goPrevTab() {
            var curIndex = this.tabs.findIndex(x => x.key == this.tab) - 1;
            if(curIndex < 0)
                curIndex = 0;

            this.goTab(this.tabs[curIndex].key);
        }
    }
}
</script>

<style scoped>

.tab-panel {
  min-height: 600px;
}
</style>